
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import AddressDetails, { AddressHandler } from './address-details';
import { useMutation } from '@apollo/client';
import { useRef, useState} from 'react';
import { GET_ORG_ADDRESSES, UPDATE_ORG_ADDRESS } from '../../../../graphql/contact-gql';
import { CancelIcon, SaveIcon } from '../../../common/icons';
import { IAddressUsage } from '../../../../types/contact';
import { notifySuccess } from '../../../../services/notification';
import SpinnerOverlay from '../../../common/spinner/spinner';
import '../../org.scss';
import Button from '../../../common/button';

type AddressUpdateProps = {
    addressUsage?: IAddressUsage;
    isOpen: boolean;
    toggle: () => void;
}

const AddressUpdate = (props: AddressUpdateProps) => {
    const {addressUsage, isOpen, toggle} = props

    const [validated, setValidated] = useState<boolean>(false)
    const addressFormRef = useRef<AddressHandler>(null);
    const [updateOrgAddress, {loading}] = useMutation(UPDATE_ORG_ADDRESS);
    const [typeaheadError, setTypeaheadError] = useState<string>("");

    const onSaveAddress = () => {
        if (addressFormRef.current && !addressFormRef.current.validate(true)) {
            setValidated(false)
            return
        }
        
        let addressInput = addressFormRef.current && addressFormRef.current.getAddress();

        updateOrgAddress({
            variables: {
                orgId: addressUsage?.businessEntityId,
                address: addressInput
            },
            refetchQueries: [{
                query: GET_ORG_ADDRESSES,
                variables: { orgId: addressUsage?.businessEntityId }
            }],
            awaitRefetchQueries: true,
            onCompleted: (data) => {
                toggle()
                data && notifySuccess()
            }
        });
    }

    const onToggle = (event: any) => {
        if (event.target.nodeName !== 'SELECT') {
            toggle()
        }
    }

    const onChange = () => {
        setValidated(!!addressFormRef.current?.validate(false))
    }

    return (<>
            {loading && <SpinnerOverlay />}
            <Modal size="lg" isOpen={isOpen} toggle={onToggle} scrollable backdrop="static" autoFocus={false}>
                <ModalHeader toggle={toggle} tag={'h2'}>Update Organization Address Details</ModalHeader>
                <ModalBody>
                    <AddressDetails addressUsage={addressUsage} ref={addressFormRef} mandatory={true} onChange={onChange} onError={setTypeaheadError} autoFocus={true}/>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={onSaveAddress} disabled={!validated|| !!typeaheadError}>
                        <SaveIcon/> Update
                    </Button>
                    <Button color="secondary" onClick={toggle}>
                        <CancelIcon/> Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    )
}

export default AddressUpdate;
